import { useSentry } from '@/composables/useSentry';
import { registerGlobalErrorHandling } from '@/helpers/globalErrorHandling.helper';
import { getAppConfig } from '@/helpers/sentry.helper';
import '@/services/api.service';
import axios from 'axios';
import { createPinia } from 'pinia';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import { createApp, markRaw } from 'vue';
import VueAxios from 'vue-axios';
import App from './App.vue';
import router from './router';

const app = createApp(App);

const Vue = app;

const pinia = createPinia();

const config = getAppConfig();

pinia.use(piniaPluginPersistedState);

pinia.use(({ store }) => {
  store.router = markRaw(router);
});

useSentry({
  app,
  router,
  pinia,
  config,
});

Vue.use(router);
// @ts-ignore
Vue.use(VueAxios, axios);
Vue.use(pinia);

registerGlobalErrorHandling(app, pinia);

Vue.mount('#app');
